import React from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Typography,
} from '@material-ui/core';

import Alert from '../../common/components/Alert';

import InterestForm from './interestForm';
import RequestForm from './requestForm';

import classes from '../../css/getCSS';


const interestrequestDialog = (props) => {
  let title = 'Loading title..';
  if (props.type === 'interests') {
    title = 'Express Interest';
  }
  if (props.type === 'requests') {
    title = 'Send Request';
  }

  let form = null;
  if (!props.actionLoading) {
    if (props.type === 'interests' && !props.interested) {
      form = (
        <InterestForm
          inputs={props.interestForm}
          inputChangedHandler={props.inputChangedHandler}
        />
      );
    } else if (props.type === 'requests' && !props.requested) {
      form = (
        <RequestForm
          inputs={props.requestForm}
          inputChangedHandler={props.inputChangedHandler}
        />
      );
    }
  }

  let loading = null;
  if (props.actionLoading) {
    loading = (
      <div align="center">
        <CircularProgress align="center" size={50} /> <br />
        <Typography variant="body1">Loading. Please wait</Typography>
      </div>
    );
  }

  let errorAlert = null;
  if (props.actionError) {
    errorAlert = <Alert type="danger">{props.actionError}</Alert>;
  }

  let success = null;
  if (props.interested && props.type === 'interests') {
    success = (
      <Typography align="center" variant="subheading">
        Interest Sent! You can close this dialog now.
      </Typography>
    );
  }
  if (props.requested && props.type === 'requests') {
    success = (
      <Typography align="center" variant="subheading">
        Request Sent! You can close this dialog now.
      </Typography>
    );
  }

  let confirmButton = null;
  if (props.confirmVisible) {
    confirmButton = (
      <Button type="submit" color="primary">
        Send
      </Button>
    );
  }

  return (
    <Dialog
      fullWidth
      open={props.open}
      onClose={props.close}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      classes={{
        paper: classes.reqDialogCard,
        root: classes.reqDialogRoot,
      }}
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <form method="post" onSubmit={props.submitHandler}>
        <DialogContent classes={{ root: classes.reqDialogContent }}>
          {form}
          {loading}
          {errorAlert}
          {success}
        </DialogContent>
        <DialogActions>
          <Button onClick={props.close} color="primary">
            Cancel
          </Button>
          {confirmButton}
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default interestrequestDialog;



// WEBPACK FOOTER //
// ./src/activities/components/InterestRequestDialog.js